export function areStringsEquivalent(a, b) {
  return (a || '').trim().toUpperCase() === (b || '').trim().toUpperCase()
}
